export default __webpack_public_path__ + "static/media/u_video_bg.950dcdee.png";